import { parseStyleString, getAdvanced, getBackgroundImages } from '../utils';
import type { ContentTypeObject, CustomHtmlElement } from '../../types/pbTypes';
import type { PbColumnGroup } from '../../types/pbBlocks';

export type ColumnGroupType = ContentTypeObject & PbColumnGroup;

/**
 * Aggregates the configuration of a column group element.
 * @param node
 */
export function columnGroupConfigAggregator(node: CustomHtmlElement): ColumnGroupType {
    const style = parseStyleString(node.attributes.style);

    return {
        ...getAdvanced(node, style),
        ...getBackgroundImages(node, style),
        minHeight: style?.minHeight ? style?.minHeight : undefined,
        uniqueID: node.attributes['data-pb-style'],
    };
}
